export interface ArticleMeta {
  headline: string;
  description: string;
  image?: string;
  datePublished?: string;
}

export interface SeoOverride {
  title?: string;
  description?: string;
  image?: string;
  article?: ArticleMeta;
}

type Listener = (value: SeoOverride | null) => void;

let current: SeoOverride | null = null;
const listeners = new Set<Listener>();

export function setSeoOverride(value: SeoOverride | null): void {
  current = value;
  listeners.forEach((listener) => listener(current));
}

export function subscribeSeoOverride(listener: Listener): () => void {
  listeners.add(listener);
  listener(current);
  return () => {
    listeners.delete(listener);
  };
}